



















import { defineComponent } from '@nuxtjs/composition-api'
export default defineComponent({
  props: {
    seller: {
      type: Object,
      required: true
    }
  },
  computed: {
    otherOutlets() {
      return this.seller.outlets.filter(outlet => outlet.id !== this.seller.id)
    }
  }
})
